// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-sPrL","button":"styles_button__KFwoP","overlay":"styles_overlay__ermxV","title":"styles_title__7ZKae"};